export default __webpack_public_path__ + "static/media/KamilaCamillo_04.02a84a4b.jpg";